import React from "react";
import { Dropdown } from "primereact/dropdown";
import { Tag } from "primereact/tag";

import { SelectItemOptionsType } from "primereact/selectitem";

const STATION_STATUS_OPTIONS = ["AVAILABLE", "CHARGING", "UNKNOWN"];

export const getStatusSeverity = (
  status: string
): "success" | "info" | "warning" | "danger" => {
  switch (status) {
    case "AVAILABLE":
      return "success";
    case "CHARGING":
      return "info";
    case "UNKNOWN":
      return "warning";
    default:
      return "danger";
  }
};

export const StatusFilter: React.FC<{
  value: string;
  filterCallback: (value: string, index: number) => void;
}> = ({ value, filterCallback }) => (
  <Dropdown
    value={value}
    options={STATION_STATUS_OPTIONS as SelectItemOptionsType}
    onChange={(e) => filterCallback(e.value, 0)}
    itemTemplate={(status: string) => (
      <Tag value={status} severity={getStatusSeverity(status)} />
    )}
    placeholder="Select a Status"
    className="p-column-filter"
    showClear
  />
);
